import axios from 'axios';

import { appConfig } from '../../config/appConfig';
import { auth } from '../firebase';

export const baseApi = axios.create({
  baseURL: appConfig.baseUrl,
});

baseApi.interceptors.request.use(async (config) => {
  const token = await auth.currentUser?.getIdToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});
